import type { ItemAttributes } from '@ps-smart-cp/ppfw-client';
import { ItemName, type ItemNames, Locale, Numeric } from '@ps-smart-cp/ppfw-client';

interface Schema {
  /**
   * 適用利子率
   */
  appliedInterestRate: string;
  /**
   * リース債務
   */
  leaseLiability: string;
  /**
   * 使用権資産取得価額
   */
  rightOfUseAssetAcquisitionAmount: string;
  /**
   * リース債務変動額
   */
  leaseLiabilityValuableAmt: string;
  /**
   * 使用権資産調整額
   */
  rightOfUseAssetAdjAmount: string;
  /**
   * リース債務修正損益
   */
  leaseLiabilityAdjustedProfitLoss: string;
  /**
   * 変動後帳簿価額
   */
  bookValueAfterChange: string;
}

interface Record {
  appliedInterestRate: string;
  leaseLiability: string;
  rightOfUseAssetAcquisitionAmount: string;
  leaseLiabilityValuableAmt: string;
  rightOfUseAssetAdjAmount: string;
  leaseLiabilityAdjustedProfitLoss: string;
  bookValueAfterChange: string;
}

const attributes = {
  leaseLiability: Numeric.preset.currency(),
  bookValueAfterChange: Numeric.preset.currency(),
} satisfies ItemAttributes<Schema>;

const names = {
  leaseLiability: ItemName.of([Locale.ja, 'リース債務']),
  bookValueAfterChange: ItemName.of([Locale.ja, '変更後帳簿価額']),
} satisfies ItemNames<Schema>;

const labelNames = {
  liabilityEstimate: ItemName.of([Locale.ja, 'リース債務判定情報']),
  liabilityEstimatePayment: ItemName.of([Locale.ja, 'リース債務判定用支払情報']),
  appliedInterestRate: ItemName.of([Locale.ja, '適用利子率']),
  rightOfUseAssetAcquisitionAmount: ItemName.of([Locale.ja, '使用権資産取得価額']),
  leaseLiabilityValuableAmt: ItemName.of([Locale.ja, 'リース債務変動額']),
  rightOfUseAssetAdjAmount: ItemName.of([Locale.ja, '使用権資産調整額']),
  leaseLiabilityAdjustedProfitLoss: ItemName.of([Locale.ja, 'リース債務修正損益']),
  bookValueAfterChange: ItemName.of([Locale.ja, '変更後帳簿価額']),
};

const buttonNames = {
  toLiabilityEstimateChange: ItemName.of([Locale.ja, 'リース見積変更へ']),
};

const liabilityEstimate = {
  names,
  labelNames,
  attributes,
  buttonNames,
};

interface LiabilityEstimate {
  schema: Schema;
  record: Record;
}

export type { LiabilityEstimate };
export { liabilityEstimate };
